import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import { formatMonto } from "@/utils";
import ColorType from "@/components/functionals/ColorType.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";

export default [
  {
    prop: "Id",
    label: "NO",
    width: 70,
    align: "center",
    fixed: true,
    sortable: true
  },
  {
    prop: "Title",
    label: "Descripcion",
    minWidth: 130,
    sortable: true
  },
  {
    prop: "BillingDate",
    label: "Fecha Facturacion",
    formatter: DatetimeFormatter,
    minWidth: 130,
    sortable: true
  },
  {
    prop: "Amount",
    label: "Monto",
    formatter: (row) => formatMonto(row.Amount),
    minWidth: 70,
    sortable: true
  },
  {
    prop: "PayDay",
    label: "Fecha Pago",
    formatter: DatetimeFormatter,
    minWidth: 110,
    sortable: true
  },
  // {
  //   prop: "CreatedAt",
  //   label: "Fecha Creacion",
  //   formatter: DatetimeFormatter,
  //   minWidth: 130,
  //   sortable: true
  // },
  {
    prop: "Paid",
    label: "Estado",
    formatter: ColorType,
    minWidth: 90,
    sortable: true
  },
  {
    prop: "ResponsibleName",
    label: "Responsable",
    sortable: true,
    formatter: ImagePerson,
    width: 200,
    attrs: {
      imgKey: "ResponsibleImage"
    }
  },
  {
    prop: "NameCreator",
    label: "Creado por",
    sortable: true,
    formatter: ImagePerson,
    width: 200,
    attrs: {
      imgKey: "CreatorImage"
    }
  },
  {
    prop: "NameEditor",
    label: "Editado por",
    sortable: true,
    formatter: ImagePerson,
    width: 200,
    attrs: {
      imgKey: "EditorImage"
    }
  }
];

export const ActionsInvoicesOrPayments = [
  {
    icon: "el-icon-edit",
    label: "Editar",
    command: "edit-eventFinaces"
  }
];
